import Loadable from "react-loadable";

const LazyAdminConsultants = Loadable({
  loader: () => import(/* webpackChunkName: 'admin-repositories' */ "./consultants"),
  loading: () => 'loading...'
});

export default LazyAdminConsultants;
